import React, { useState, useEffect } from 'react'
import CampHeader from '../../header/CampHeader';
import { Container } from 'react-bootstrap';

import { FiChevronLeft } from '@react-icons/all-files/fi/FiChevronLeft';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../auth/Auth';
import { nextChallengeViewModel } from './next.challenge.viewmodel';
import { ADD_CHALLENGES_ROUTE, MY_ROOM_ROUTE } from '../../../constants/routes.constants';
import CampHeaderDependant from '../../header/CampHeaderDependant';
import { bg } from '../../../constants/component.constants';
import { changeBodyClassName } from '../../../utils/utils';

const AddMoreBranches = () => {
  const history = useHistory();
  const { dependent, fetchAPI } = useAuth();
  const [selectedBranch, setSelectedBranch] = useState([]);
  const [taglist, setTaglist] = useState([]);
  const userData = dependent?.profile;
  const from = history.location.state.from;

  const getTagList = () => {
    fetchAPI(nextChallengeViewModel.getTags, { limit: 99 })
      .then((res) => {
        setTaglist(res);
      })
      .catch((err) => { });
  };

  const getBranchList = () => {
    fetchAPI(nextChallengeViewModel.getBranch)
      .then((res) => {
        setSelectedBranch(res.map(item => item.id));
      })
      .catch((err) => { });
  };

  const setBranchForAdd = (data) => {

    if (selectedBranch.indexOf(data) != -1) {
      setSelectedBranch(selectedBranch.filter(item => item != data));
    }
    else {
      setSelectedBranch([...selectedBranch, data]);
    }
  }
  const pageRedirect = () => {
    history.goBack(1);
  }

  const showSelected = (id) => {
    if (selectedBranch.indexOf(id) != -1) {
      return "selected";
    }
    else {
      return "";
    }
  }

  const addBranch = () => {
    fetchAPI(nextChallengeViewModel.addBranch, selectedBranch)
      .then((res) => {
        if (from === "favorites") {
          history.push({
            pathname: ADD_CHALLENGES_ROUTE,
            state: {
              dependent: userData
            }
          });
        }
        else {
          history.goBack();
        }
      })
      .catch((err) => { });
  };

  useEffect(() => {
    getBranchList();
    getTagList();
    // changeBodyClassName([bg.CHALLENGES]);
  }, []);

  return (
    dependent ?
      <>
        {/* <CampHeader /> */}
        {from === "favorites" ?
          <CampHeaderDependant /> : <CampHeader />}
        <div className="add-more-branches">
          {from !== "favorites" &&
            <span className="back-btn" onClick={pageRedirect}><FiChevronLeft /></span>
          }
          <Container>
            <div className="add-more-branches-inner">
              {from === "favorites" ?
                <h1>Explore the interest branches</h1>
                : <h1>Add more branches to your TaleTree</h1>
              }
              <h4>Explore the interest branches of TaleTree to find projects and new friends who like the same cool things as you,&nbsp;
                <span className='text-style'>{userData.nick_name}!</span></h4>
              {from === "favorites" ?
                <p>Select three areas that interest you {userData.nick_name} :)</p>
                : <p>Select some areas that interest you {userData.nick_name} :)</p>
              }
              <div className="interest-lists">
                <ul>
                  {taglist.map((tag, index) => (
                    <li key={index} id={tag.id} onClick={e => setBranchForAdd(tag.id)} className={showSelected(tag.id)}>{tag.tag}</li>
                  ))}
                </ul>
                {from === "favorites" ? <button type='button' className="add-btn-interest gred-btn" onClick={addBranch} disabled={selectedBranch.length < 3 || selectedBranch.length > 10}>NEXT</button>
                  : <button type='button' className="add-btn-interest gred-btn" onClick={addBranch} disabled={selectedBranch.length < 3 || selectedBranch.length > 10}>ADD</button>
                }
              </div>
            </div>
          </Container>
        </div>
      </>
      : ""
  )
}

export default AddMoreBranches